export const MOVEMENT_TYPE_OPTIONS = [
  { value: "INCOME", label: "Ingreso" },
  { value: "EXPENSE", label: "Egreso" },
  { value: "BOTH", label: "Ambos" },
];

export const DEFAULT_MOVEMENT_OPTIONS = MOVEMENT_TYPE_OPTIONS.filter(
  (option) => option.value !== "BOTH"
);

export const ACCOUNT_TYPE_OPTIONS = [
  { value: "CASH", label: "Efectivo" },
  { value: "BANK", label: "Banco" },
  { value: "WALLET", label: "Billetera virtual" },
  { value: "TICKETER", label: "Ticketera" },
  { value: "RESERVE", label: "Reserva" },
  { value: "OTHER", label: "Otro" },
];

export function getMovementTypeLabel(value) {
  return (
    MOVEMENT_TYPE_OPTIONS.find((option) => option.value === value)?.label ||
    "Ingreso"
  );
}

export function getAccountTypeLabel(value) {
  return (
    ACCOUNT_TYPE_OPTIONS.find((option) => option.value === value)?.label ||
    "Otro"
  );
}
